(function() {

    'use strict';

    angular.module('Services').factory('ClientGroupListTableService', ClientGroupListTableService);

    function ClientGroupListTableService($location, ClientService, TableLiteFactory) {
        return function (companyId) {
            var companiesListTableData = {
                tableName: 'ClientGroupListTableService',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Group',
                        onClick: function () {
                            $location.path(`/clients/${companyId}/group`);
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Group', //header name
                    viewName: 'name', //Attribute name on what to display from data
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    } //Use for sorting
                }, {
                    label: 'Description',
                    viewName: 'description',
                    filterName: 'description',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Permissions',
                    viewName: 'permissions',
                    filterName: 'roles.name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                },{
                    label: 'Office Access',
                    viewName: 'officeAccess',
                    filterName: 'offices',
                    
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(companiesListTableData,
                {
                    serviceCallback: ClientService.Group.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        'company.id': companyId
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;


            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);

                angular.forEach(data.content, function (group) {
                    group.permissions = {
                        type: 'multiLine',
                        list: []
                    };
                    group.officeAccess = {
                        type: 'multiLine',
                        list: []
                    };
                    if(group.offices.length > 0){
                        for(let i =0;i < group.offices.length;i++){
                            group.officeAccess.list.push(group.offices[i].name)
                        }
                    }else{
                        group.officeAccess.list.push('All')
                    }
                    group.name = group.name ? group.name : 'N/A';
                    group.description = group.description ? group.description : 'N/A';
                    if (group.roles.length > 0) {
                        for (var i = 0; i < group.roles.length; i++) {
                            group.permissions.list.push(group.roles[i].name);
                        }
                    }

                    //group.href = '/clients/group/details?companyId=' + group.company.id + '&id=' + group.id;
                    group.href = `/clients/${group.company.id}/group/${group.id}`;
                    companiesListTableData.data.push(group);
                });
                /*** END - Building of Data ***/

            };
            this.tableData = companiesListTableData;
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ClientGroupListTableService.js